import { render, staticRenderFns } from "./my-add.vue?vue&type=template&id=4b53384c&scoped=true&"
import script from "./my-add.vue?vue&type=script&lang=js&"
export * from "./my-add.vue?vue&type=script&lang=js&"
import style0 from "./my-add.vue?vue&type=style&index=0&id=4b53384c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53384c",
  null
  
)

export default component.exports